import React from 'react';

export default function assignProps(Component, props) {
    class AssignProps extends React.Component {
        render() {
            return <Component {...props} {...this.props} />;
        }
    };

    AssignProps.displayName = `assignProps(${Component.displayName || Component.name})`;

    return AssignProps;
}



// WEBPACK FOOTER //
// ./node_modules/@99designs/utils/app/assignProps.js